import React, { createContext } from "react";
import { useLocalStorage, localStorageKeys } from "@/services/storage";
import {
	ActionTypes,
	Action,
	State,
	Dispatch,
	AuthProviderProps,
} from "./types";

const AuthContext = createContext<
	{ state: State; dispatch: Dispatch } | undefined
>(undefined);

function authReducer(state: State, action: Action) {
	switch (action.type) {
		case ActionTypes.LOGOUT: {
			localStorage.clear();
			return {
				...state,
				token: "",
				user: null,
			};
		}
		case ActionTypes.LOGIN: {
			const { token } = action.payload;
			localStorage.setItem(localStorageKeys.token, token);
			return {
				...state,
				token,
				user: null,
			};
		}
		case ActionTypes.SET_USER: {
			return {
				...state,
				user: action.payload,
			};
		}
		default: {
			// TODO: still enhancing the types here
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			throw new Error(`Unhandled action type: ${action.type}`);
		}
	}
}

export function AuthProvider({ children }: AuthProviderProps) {
	const { storedValue: token } = useLocalStorage(localStorageKeys.token, "");

	const [state, dispatch] = React.useReducer(authReducer, {
		token,
		user: null,
	});

	// eslint-disable-next-line react/jsx-no-constructed-context-values
	const value = { state, dispatch };

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => {
	const context = React.useContext(AuthContext);
	if (context === undefined) {
		throw new Error("useAuth must be used within a AuthProvider");
	}
	const { state, dispatch } = context;
	return { state, dispatch };
};
